/* eslint-disable */
export default function getQuestionType(num) {
    let type = null;
    switch (num) {
        case "1":
            type = "True or False";
            break;
        case "2":
            type = "Multiple Choices";
            break;
        case "3":
            type = "Free Text";
            break;
        case "4":
            type = "Rank";
            break;
        case "5":
            type = "Arrange";
            break;
    }

    return type;
}
